import { render, staticRenderFns } from "./DetailLayout.vue?vue&type=template&id=5384f51a&scoped=true&"
import script from "./DetailLayout.vue?vue&type=script&lang=js&"
export * from "./DetailLayout.vue?vue&type=script&lang=js&"
import style0 from "./DetailLayout.vue?vue&type=style&index=0&id=5384f51a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5384f51a",
  null
  
)

export default component.exports